
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/classifieds-emitter/[id]",
      function () {
        return require("private-next-pages/classifieds-emitter/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/classifieds-emitter/[id]"])
      });
    }
  